<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<h2 mat-dialog-title>{{'assign.fde.add-workstation-dialog-title' | translate}}</h2>

<mat-dialog-content>
    <form [formGroup]="form">
        <fieldset [disabled]="this.loading$ | async">
            <mat-form-field appearance="outline" class="add-workstation-id-form-field" subscriptSizing="dynamic">
                <mat-label>{{'assign.fde.add-workstation-dialog-label' | translate}}</mat-label>
                <textarea matInput type="text" formControlName="serial" (keydown.enter)="onEnterPressed($event)"
                          (input)="onDataChanged()" id="fde-workstation-textarea" cdkTextareaAutosize
                          cdkAutosizeMinRows="6" cdkAutosizeMaxRows="12">
                </textarea>
            </mat-form-field>
            @if (error_occurred) {
                <div class="mat-error">{{error_occurred | translate}}</div>
                @if (errorMessage.length > 0) {
                    <div class="mat-error dup-serials-list">
                        {{ errorMessage.split(",") }}
                    </div>
                }
            }
            @if (form.get('serial')?.errors?.duplicateSerials) {
                <div class="mat-error">{{'assign.pba.duplicate-serials-in-input' | translate}}</div>
                <div class="mat-error dup-serials-list">
                    @for (dup of form.get('serial')?.errors?.duplicateSerials.duplicates.slice(0, 3); track $index) {
                        @if ($index < 2) {
                            <span>{{ dup }},&nbsp;</span>
                        } @else {
                            <span>{{ dup }}&nbsp;</span>
                        }
                    }
                    @if (form.get('serial')?.errors?.duplicateSerials.duplicates.length > 3) {
                        <span>{{ 'assign.pba.and-n-more' | translate : {n: form.get('serial')?.errors?.duplicateSerials.duplicates.length - 3} }}</span>
                    }
                </div>
            }
            @if (isMSP(data.user)) {
                <mat-radio-group formControlName="licensingOption"
                                 class="license-options" aria-label="Select an option">
                  <mat-radio-button [value]="serialLicensingOptionType.NO_LICENSE">
                      {{'assign.fde.add-dialog.radio-button-1' | translate}}
                      <span class="mdi mdi-information-outline"
                            matTooltipPosition="right"
                            matTooltip="{{'assign.fde.add-dialog.radio-button-1-tooltip' | translate}}">
                      </span>
                  </mat-radio-button>
                  <mat-radio-button [value]="serialLicensingOptionType.NEW_SERIALS_LICENSED">
                      {{'assign.fde.add-dialog.radio-button-2' | translate}}
                      <span class="mdi mdi-information-outline"
                            matTooltipPosition="right"
                            matTooltip="{{'assign.fde.add-dialog.radio-button-2-tooltip' | translate}}">
                      </span>
                  </mat-radio-button>
                  <mat-radio-button [value]="serialLicensingOptionType.UNLICENSED_SERIALS_LICENSED">
                      {{'assign.fde.add-dialog.radio-button-3' | translate}}
                      <span class="mdi mdi-information-outline"
                            matTooltipPosition="right"
                            matTooltip="{{'assign.fde.add-dialog.radio-button-3-tooltip' | translate}}">
                      </span>
                  </mat-radio-button>
                  <mat-radio-button [value]="serialLicensingOptionType.ALL_EXISTING_LICENSED"
                                    matTooltip="">
                      {{'assign.fde.add-dialog.radio-button-4' | translate}}
                      <span class="mdi mdi-information-outline"
                            matTooltipPosition="right"
                            matTooltip="{{'assign.fde.add-dialog.radio-button-4-tooltip' | translate}}">
                      </span>
                  </mat-radio-button>
                </mat-radio-group>
                <mat-form-field appearance="outline">
                    <mat-label>{{'MAINT_EXPIRES' | translate}}</mat-label>
                    <input matInput formControlName="maintenanceExpiration" name="maintenanceExpiration"
                           [value]="data.maintenanceExpiration" [matDatepicker]="picker">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            }
        </fieldset>
    </form>
</mat-dialog-content>

<div mat-dialog-actions align="end">
    <button mat-raised-button type="button" id="close-button"
            (click)="onCancelClick()">{{'H_CLOSE' | translate}}
    </button>
    <button mat-raised-button type="button" id="save-button" color="primary"
            (click)="onSaveClick()" [disabled]="!form.valid || (loading$ | async)">
            @if (loading$ | async) {
                <span class="mdi mdi-dots-circle mdi-spin saving-spinner"></span>
                <span>{{'groups.saving' | translate}}</span>
            } @else {
                <span>{{'SAVE' | translate}}</span>
            }
    </button>
</div>
